import { render, staticRenderFns } from "./ProjectCreationModal.vue?vue&type=template&id=271d8dc3&scoped=true&"
import script from "./ProjectCreationModal.vue?vue&type=script&lang=js&"
export * from "./ProjectCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d8dc3",
  null
  
)

export default component.exports